import React from "react";

/** โทนตาม $hv4-tones ใน _hisv4-theme.scss */
export type ChipV4Tone =
  | "neutral"
  | "grey"
  | "warn"
  | "amber"
  | "expire"
  | "danger"
  | "ok"
  | "sky"
  | "navy"
  | "teal"
  | "purple"
  | "purple-soft"
  | "orange"
  | "blue-solid"
  | "danger-solid"
  | "warn-solid";

type ChipV4Props = {
  tone: ChipV4Tone;
  size?: "md" | "sm";
  bold?: boolean;
  className?: string;
  children: React.ReactNode;
};

/** ป้ายของ HIS V4 (class hv4-chip ใน _hisv4-base.scss) */
const ChipV4 = (props: ChipV4Props) => {
  const classes = [
    "hv4-chip",
    `hv4-chip-${props.tone}`,
    props.size === "sm" && "hv4-chip-sm",
    props.bold && "hv4-chip-bold",
    props.className,
  ];

  return <span className={classes.filter(Boolean).join(" ")}>{props.children}</span>;
};

export default ChipV4;
